// extracted by mini-css-extract-plugin
export default {"rightAlignedElement":"theming-form-group-wrapper__right-aligned-element__oiPm5"};